import React from 'react'
import MuiTabs, { TabsProps as MuiTabsProps } from '@material-ui/core/Tabs'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { Tab } from './components'
import { TabPanel } from '../TabPanel'
import clsx from 'clsx'

const useStyles = makeStyles({
  tabs: {
    borderBottom: `1px dashed ${mutualTheme.palette.grey[400]}`
  },
  indicator: {
    backgroundColor: mutualTheme.palette.secondary.main
  }
})

export type TabLabel = {
  title: string,
  icon?: JSX.Element
}

export type TabsProps = MuiTabsProps & {
  labels: TabLabel[],
  className?: string
}

export const Tabs: React.FC<TabsProps> = (props) => {
  const classes = useStyles()
  const { labels, children, value, className } = props
  return (
    <>
      <MuiTabs
        {...props}
        classes={{ root: clsx(classes.tabs, className), indicator: classes.indicator }}
      >
        {labels.map((label, index) => (
          <Tab
            key={index}
            label={label.title}
            id={`tab-${index}`}
            aria-controls={`tabpanel-${index}`}
            icon={label.icon}
          />
        ))}
      </MuiTabs>

      {React.Children.map(children, (child, index) => (
        <TabPanel currentTab={value} index={index}>{child}</TabPanel>
      ))}
    </>
  )
}
